export const RECORDER_STOP_EVENT_TIMEOUT_MS = 5_000;
export const RECORDER_WRITE_DRAIN_TIMEOUT_MS = 10_000;

// A remote tab releases its Web Lock only after both stop phases settle.
// Leave an additional five seconds for BroadcastChannel delivery and task
// scheduling before sign-out reports that another tab is unresponsive.
/**
 * How long sign-out waits to hear that any other tab exists at all.
 *
 * A tab answers the moment the message arrives, before it starts its own
 * teardown, so this covers BroadcastChannel delivery and one task hop rather
 * than any real work. Nothing answering means nothing else is open, and
 * sign-out carries on.
 */
export const RECORDER_SIGN_OUT_ACK_WINDOW_MS = 250;

export const RECORDER_SIGN_OUT_LEASE_TIMEOUT_MS =
  RECORDER_STOP_EVENT_TIMEOUT_MS + RECORDER_WRITE_DRAIN_TIMEOUT_MS + 5_000;
